//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import DisplayComments from "./displayComments";
//#endregion

function useShowCommentsDialog() {
  const getCommentsDialog = (projectTimeId: number): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.Comments),
      titleIcon: IconDefinitionConstants.WCommentDots,
      dialogType: DialogEnums.DialogType.Content,
      children: <DisplayComments projectTimeId={projectTimeId}></DisplayComments>,
      maxWidth: "sm",
      hideCancelButton: true,
    };
  };

  return { getCommentsDialog };
}

export default useShowCommentsDialog;
